import { Center, Loader, Stack, Text } from '@mantine/core';
import { AuthenticateWithRedirectCallback } from '@clerk/clerk-react';

/**
 * Where a social provider returns to.
 *
 * Clerk's callback component finishes the OAuth handshake and then redirects;
 * it renders nothing, so this supplies something to look at during the second
 * or two it takes. Without a route here the provider returns to a 404 and the
 * sign-in silently dies at the last step.
 */
export function SsoCallback() {
  return (
    <Center mih="100vh">
      <Stack align="center" gap="sm">
        <Loader />
        <Text size="sm" c="dimmed">
          Finishing sign-in…
        </Text>
        <AuthenticateWithRedirectCallback signInFallbackRedirectUrl="/app" signUpFallbackRedirectUrl="/app" />
      </Stack>
    </Center>
  );
}
